import React, {Component} from "react";
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import {List, ListItem, ListItemText} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const drawerWidth = 300;

const styles = theme => ({
  root: {
    //flexGrow: 1,
    //height: 430,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex'
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
    height: "100%"
  }
});

let Sidebar = class Sidebar extends Component {
  render() {
    const {classes, sidebarList, active, onClick, headerComponent} = this.props;

    return (
      <div className={classes.root}>
        <Drawer
          variant="permanent"
          classes={{
          paper: classes.drawerPaper
        }}>
          {headerComponent()}
          <List component="nav">
            {populateSideBar({sidebarList, active:active||0, onClick})}
          </List>
        </Drawer>
      </div>
    );
  }
}

function populateSideBar({sidebarList, active, onClick}) {
  return Object
    .keys(sidebarList)
    .map((key, i) => {
      let el = sidebarList[key];
      return (
        <ListItem
          className={active === key
          ? "selected"
          : null}
          button
          onClick={()=>onClick(key)}
          key={key}>
          <ListItemText>
            <Typography
              variant="title"
              gutterBottom
              color={active === key
              ? "secondary"
              : "inherit"}>
              {el.title}
            </Typography>
          </ListItemText>
        </ListItem>
      )
    })
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  sidebarList: PropTypes.object,
  active: PropTypes.string,
  onClick: PropTypes.func,
  headerComponent: PropTypes.func
};

export default withStyles(styles)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js